module.exports = __webpack_public_path__ + "static/media/woven.4c16d936.webp";